export default __webpack_public_path__ + "static/media/cookie_king--light.0638d0c6.svg";